import { IController, IComponentOptions } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IGoal } from "@gtmhub/goals/models";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { IDropdownButtonMenuItem } from "../ui/models";
import { FeatureToggleV2Service } from "@gtmhub/featureToggle";
import { FeatureFlag } from "@gtmhub/featureToggle/models";

export class CreateOkrButtonCtrl implements IController {
  disabled: boolean;
  disabledMessageTemplate: string;
  dropdownButtonMenuItems: IDropdownButtonMenuItem[];
  indicators = {
    loading: true,
  };

  static $inject = ["$rootScope", "$state", "FeatureToggleV2Service"];

  constructor(private $rootScope: IGtmhubRootScopeService, private $state: StateService, private featureToggleV2Service: FeatureToggleV2Service) {}

  $onInit() {
    this.dropdownButtonMenuItems = [
      {
        e2eData: "create-okr-menu-item-option",
        textKey: "create_okr",
        descriptionKey: "directly_add_your_okrs",
        action: { handler: () => this.openCreateGoalForm() },
        imageSrc: "/dist/img/icons/goal.svg",
      },
      {
        textKey: "choose_from_template",
        descriptionKey: "get_inspiration_marketplace",
        action: { href: "/marketplace/okrs-examples" },
        imageSrc: require("wwwroot/img/icons/marketplace.svg"),
        externalLink: true,
      },
    ];
    this.featureToggleV2Service.isFeatureAvailable(FeatureFlag.ModuleWhiteboards).then((enabled) => {
      if (enabled) {
        this.dropdownButtonMenuItems.push({
          textKey: "brainstorm_and_ideate",
          descriptionKey: "use_a_whiteboard_to_draft_okrs",
          action: { state: "gtmhub.whiteboards" },
          imageSrc: require("wwwroot/img/icons/whiteboard.svg"),
        });
      }
      this.indicators.loading = false;
    });
  }

  private openCreateGoalForm(goal: Partial<IGoal> = { id: null }): void {
    const currentState = this.$state.current.name.split(".")[2];
    // refactor
    const goto =
      currentState === "overview" || currentState === "alignmentSidebar" || this.$state.current.name.includes("home")
        ? `${this.$state.current.name}._goalForm.form`
        : "gtmhub.goals.all._goalForm.form";

    if (this.$rootScope.isMsTeamsState) {
      this.$state.go("gtmhub.msTeamsHome._goalForm.form", goal);
      return;
    }

    this.$state.go(goto, goal);
  }
}

export const CreateOkrButtonComponent: IComponentOptions = {
  controller: CreateOkrButtonCtrl,
  templateUrl: require("./create-okr-button.jade"),
  bindings: {
    disabled: "<",
    disabledMessageTemplate: "@",
  },
};
